import { render, staticRenderFns } from "./MobilePreview.vue?vue&type=template&id=c6f00730&scoped=true"
import script from "./MobilePreview.vue?vue&type=script&lang=js"
export * from "./MobilePreview.vue?vue&type=script&lang=js"
import style0 from "./MobilePreview.vue?vue&type=style&index=0&id=c6f00730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f00730",
  null
  
)

export default component.exports